import api from "@/api";
import apiad from "@/apiad";
import router from "@/router";
import { getField, updateField } from "vuex-map-fields";

const testPayload = [
  {
    id: 1,
    name: "Test Category",
    description: "Test Description",
    created_time: "2018-10-23 13:27:25",
  },
];

export default {
  namespaced: true,

  state: {
    categories: [],
    category: { name: "", description: "" },
    errorState: "",
  },

  getters: {
    formatCategories: (state) =>
      state.categories.map((item) => ({
        ...item,
        value: item.id,
        title: item.name,
        name: item.name,
      })),
  },

  mutations: {
    SET_NEWS_CATEGORIES(state, payload) {
      state.categories = payload;
    },
    SET_NEWS_CATEGORY(state, payload) {
      state.category = payload;
    },
    ADD_NEWS_CATEGORY(state, item) {
      state.categories.push(item);
    },
    SET_ERROR_STATE(state, payload) {
      state.errorState = payload;
    },
  },
  actions: {
    /**
     * Get a list of the news categories available
     */
    async list({ commit }, params) {
      let endpoint = "/news/categories";

      if (params && params.flat) {
        endpoint = `${endpoint}/flat`;
      }

      let resp;

      try {
        resp = await api().get(endpoint);
        commit("SET_NEWS_CATEGORIES", resp.data.data.category);
        commit("SET_ERROR_STATE", "");
        return Promise.resolve(resp.data.data.category);
      } catch (err) {
        if (err.response.data.data.length < 1) {
          commit("SET_NEWS_CATEGORIES", []);
          return Promise.resolve([]);
        }
        const error = err.response.data.error.message || "There was an error";
        commit(
          "SET_ERROR_STATE",
          error.status
            ? error.status
            : "Sorry, there was an error.  Please try again"
        );
        // commit('SET_NEWS_CATEGORIES', testPayload);
        throw err;
      }
    },

    /**
     * Get a single category
     */
    read({ commit }, id) {
      const story = api()
        .get(`/news/category/${id}`)
        .then((resp) => {
          commit("SET_NEWS_CATEGORY", resp.data.data.category[0]);
          commit("SET_ERROR_STATE", "");
        })
        .catch((err) => {
          const error = err.response.data.error.message || "There was an error";
          commit("SET_ERROR_STATE", error);
          // commit('SET_NEWS_CATEGORIES', testPayload);
          throw err;
        });
    },

    /**
     * create a category
     * validation should be handled already, but take into account server side
     */
    create({ commit, state, dispatch, rootState }, categoryData) {
      api()
        .put("/news/category", { category: categoryData })
        .then((resp) => {
          const category = resp.data.data.category[0];
          // dispatch('list');
          // send a notification
          dispatch(
            "notifications/create",
            {
              body: `The category <b>${category.name}</b> was created`,
              type: "success",
            },
            { root: true }
          );

          // add to new list... no point re-calling API, just merge
          // commit('ADD_NEWS_CATEGORY', category);
        })
        .catch((err) => {
          if (
            err.response &&
            hasProp(err.response.data.meta, "duplicate_category")
          ) {
            const duplicateCategory = err.response.data.meta.duplicate_category;
            dispatch(
              "notifications/create",
              {
                title: "Error!",
                body: `A category with the name <b>${duplicateCategory.name}</b> already exists`,
                type: "danger",
                timeout: 12000,
              },
              { root: true }
            );
          }
          commit("SET_ERROR_STATE", err);
        });
    },

    /**
     * Update an existing category
     */
    update({ commit, state, dispatch, rootState }, categoryData) {
      api()
        .put(`/news/category/${categoryData.id}`, { category: categoryData })
        .then((resp) => {
          const category = resp.data.data.category[0];
          dispatch("list");
          // send a notification
          dispatch(
            "notifications/create",
            {
              body: `The category <b>${category.name}</b> was updated`,
              type: "success",
            },
            { root: true }
          );

          // add to new list... no point re-calling API, just merge
          // commit('ADD_NEWS_CATEGORY', category);
        })
        .catch((err) => {
          if (
            err.response &&
            hasProp(err.response.data.meta, "duplicate_category")
          ) {
            const duplicateCategory = err.response.data.meta.duplicate_category;
            dispatch(
              "notifications/create",
              {
                title: "Error!",
                body: `A category with the name <b>${duplicateCategory.name}</b> already exists`,
                type: "danger",
                timeout: 12000,
              },
              { root: true }
            );
          }
          commit("SET_ERROR_STATE", err);
        });
    },

    /**
     * Delete an existing category
     */
    delete({ commit, dispatch }, categoryId) {
      api()
        .delete(`/news/category/${categoryId}`)
        .then((resp) => {
          dispatch("list");
          dispatch("notifications/create", {
            body: "The category was deleted",
            type: "success",
          });
        })
        .catch((err) => {
          commit("SET_ERROR_STATE", err);
        });
    },
  },
};
